export const Logo = () => (
    <svg
        data-testid="collapsed-logo"
        xmlns="http://www.w3.org/2000/svg"
        width="40"
        height="40"
        viewBox="0 0 40 40"
        fill="none"
    >
        <g clipPath="url(#clip0_226_94529)">
            <g clipPath="url(#clip1_226_94529)">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M32 20C32 26.6274 26.6274 32 20 32C13.3726 32 8 26.6274 8 20C8 13.3726 13.3726 8 20 8C26.6274 8 32 13.3726 32 20ZM14.5909 16.6363V25.6363H14.6364H17.3636V16.7727C17.3636 16.3636 17.5 16 17.7273 15.7727C17.9546 15.5454 18.2727 15.4091 18.6818 15.4091H21.1364V13.0454H18.1818C17.0455 13.0454 16.1818 13.3636 15.5455 14C14.9091 14.6363 14.5909 15.5 14.5909 16.6363ZM23.7727 20.4545C24.7016 20.4545 25.4546 19.7016 25.4546 18.7727C25.4546 17.8439 24.7016 17.0909 23.7727 17.0909C22.8439 17.0909 22.0909 17.8439 22.0909 18.7727C22.0909 19.7016 22.8439 20.4545 23.7727 20.4545ZM25.4546 24C25.4546 24.9289 24.7016 25.6818 23.7727 25.6818C22.8439 25.6818 22.0909 24.9289 22.0909 24C22.0909 23.0712 22.8439 22.3182 23.7727 22.3182C24.7016 22.3182 25.4546 23.0712 25.4546 24Z"
                    fill="currentColor"
                />
            </g>
        </g>
        <defs>
            <clipPath id="clip0_226_94529">
                <rect width="40" height="40" fill="white" />
            </clipPath>
            <clipPath id="clip1_226_94529">
                <rect width="24" height="24" fill="white" transform="translate(8 8)" />
            </clipPath>
        </defs>
    </svg>
);
